import { AxiosRequestConfig } from 'axios'

import { get } from './inner-store'
import { STORE } from './constants'

interface customAxiosRequestConfig extends AxiosRequestConfig {
  withAuth?: boolean
}

const requestInterceptor = (
  config: customAxiosRequestConfig,
): AxiosRequestConfig => {
  const access_token = get(STORE.access_token)
  const withAuth =
    config.withAuth === undefined ? true : config.withAuth

  if (access_token !== undefined && withAuth) {
    config.headers = {
      ...config.headers,
      ...{ Authorization: `Bearer ${access_token}` },
    }
  }

  return config
}

export { requestInterceptor }
